import axios from "axios";
import cacheAdapterEnhancer from "./cacheAdapterEnhancer";

const http = axios.create({
  // cache will be enabled by default
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    maxAge: 1000 * 30,
  }),
});

export default {
  getNextLevel: function (baseApiUrl, id, childSortOrder, userOrganisationUids, userProgramCodes, userUmuId, absoluteUrl) {
    let lang = document.documentElement.lang;
    var response = http.post(
      `${baseApiUrl}/Meny`,
      {
        id: Number(id),
        sort: Number(childSortOrder),
        lang: lang,
        userOrganisationUids: userOrganisationUids,
        userProgramCodes: userProgramCodes,
        userUmuId: userUmuId,
        absoluteUrl: absoluteUrl,
      }
    );
    return response;
  },
  
  loadPartialView: function (url) {
    var response = axios.get(url);
    return response;
  },
};
